<!--检验检测资质-->
<template>
  <div class="location-number">
    <seamless-scroll
      class="locaiton-scroll"
      :data='qualificationList'
      :class-option="classOption"
    >
      <div
        class="item-class"
        v-for="(item,index) in qualificationList"
        :key="index"
      >
        <div class="item-title">{{item.number}}</div>
        <div class="item-content">
          <div class="content-left">
            <p>{{item.productName}}</p>
          </div>
          <div class="content-middle"></div>
          <div class="content-right">{{item.productModel}}</div>
        </div>
        <div class="item-address">{{item.enterpriseName}}</div>
        <div class="item-time">有效期：<span style="color: #DEFFE9;">{{item.time}}</span></div>
        <div class="item-detail" @click="goPage(item.url)"></div>
      </div>
    </seamless-scroll>
  </div>
</template>

<script>
export default {
  props: {
    qualificationList: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      classOption: {
        step: 0.5,
        limitMoveNum: 2
      },
 
    }
  },
  methods: {
    goPage(url) {
      window.location.href = url
      const urlInfo = new URL(url);
      const locProtocol = window.location.protocol;
      let file = null;
      if(locProtocol.indexOf('https') >= 0) {
        file = `/tohttp${urlInfo.pathname}${urlInfo.search}`
      }else {
        file = url;
      }
      window.open(file)
      // window.open(url)
    },
  },
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.location-number {
  height: 100%;
  font-family: Microsoft YaHei;
  .locaiton-scroll {
    height: 100%;
    overflow: hidden;
  }
  .item-class {
    position: relative;
    width: vw(314);
    height: vh(128);
    padding: vh(6) vw(15);
    margin-top: vh(8);
    background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_list_jdxx.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: fontSize(14);
    color: #DEFFE9;
    .item-title {
      padding-bottom: vh(4);
      font-weight: bold;
      font-style: italic;
      background: linear-gradient(180deg, #FFFFFF 35.009765625%, #BDFFCC 60%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      border-bottom: 1px dashed #0D7330;
    }
    .item-content {
      display: flex;
      margin-top: vh(2);
      padding-bottom: vh(2);
      border-bottom: 1px dashed #0D7330;
      color: #DEFFE9;
      .content-left {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          width: vw(112);
          text-align: center;
        }
      }
      .content-middle {
        width: vw(1);
        height: vh(42);
        background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_titlemenu_nl_line.png");
        background-size: 100%;
        background-repeat: no-repeat;
      }
      .content-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          width: vw(112);
          text-align: center;
        }
      }
    }
    .item-address {
      margin-top: vh(4);
      max-width: vw(278);
      white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 显示省略号 */
    }
    .item-time {
      color: #50A66E;
    }
    .item-detail {
      position: absolute;
      right: 0;
      bottom: 0;
      width: vw(40);
      height: vh(20);
      background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/btn_more.png");
      background-size: 100%;
      background-repeat: no-repeat;
      cursor: pointer; 
    }
  }
 
 
}
</style>
